export enum PolicyLimitType {
  ActivityLogRetentionDays = 'activity-log-retention-days',
  MaxRecordsPerDatabase = 'max-records-per-database',
  MaxDatabases = 'max-databases',
  StorageMegabytes = 'storage-megabytes',
  MaxUsers = 'max-users',
  MaxGuests = 'max-guests',
  SlaPercent = 'sla-percent',
}
